import { render, staticRenderFns } from "./ExternalContent.vue?vue&type=template&id=0096cdc9&scoped=true&"
import script from "./ExternalContent.vue?vue&type=script&lang=js&"
export * from "./ExternalContent.vue?vue&type=script&lang=js&"
import style0 from "./ExternalContent.vue?vue&type=style&index=0&id=0096cdc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096cdc9",
  null
  
)

export default component.exports